import React from 'react';

export default function FieldDropdown_TableValueEmpty(props:any) {


    // {_.get(props.field.components, 'ValueIcon', false)}
    // {props.field.placeholder}

    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-no-accent-default ui5-field-dropdown-inline-editable w-100-percent", props.className)} onClick={props.onClick}>

            </div>
            {props.children}
        </React.Fragment>
    )

}
